import ax from "./client";
import { buildErrorResponse } from "@/lib/error";
import { ApiResponse } from "muminsmart-utils";
import { endpoints, FileType, ICreateFileResponse } from "muminsmart-utils";

export const fetchUploadFile = async (
  type: FileType,
  file: File,
): Promise<ApiResponse<ICreateFileResponse | null>> => {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("file", file);

  try {
    const response = await ax.post<ICreateFileResponse>(
      endpoints.file.index,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return {
      success: true,
      data: response.data,
      message: "File uploaded successfully",
    };
  } catch (error: unknown) {
    return buildErrorResponse(
      error,
      "Error uploading file",
      "Error uploading file:",
      null,
    );
  }
};
